export default class PaginationInfo {
  constructor(pageNumber, pageSize, fullCount) {
    this.pageNumber = pageNumber;
    this.pageSize   = pageSize;
    this.fullCount  = fullCount;
    this.pageCount  = Math.ceil(this.fullCount / this.pageSize);
  }
}
